(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calecon-offer"] && !Shopify.designMode) return;
  try {
    class CaleconOffer extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
      this.submitButton = this.querySelector('[data-offer-submit]');
      this.buttonText = this.querySelector('[data-offer-button-text]');
      this.spinner = this.querySelector('.calecon-offer__spinner');
      this.message = this.querySelector('[data-offer-message]');
      this.total = this.querySelector('[data-offer-total]');
      this.translations = this.readTranslations();
      this.section = this.closest('.shopify-section');
      this.onChange = this.handleChange.bind(this);
      this.onSubmit = this.addOffer.bind(this);
      this.onVariantUpdate = this.handleVariantUpdate.bind(this);
      this.addEventListener('change', this.onChange);
      this.submitButton.addEventListener('click', this.onSubmit);
      this.section?.addEventListener('variant:update', this.onVariantUpdate);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.submitButton?.removeEventListener('click', this.onSubmit);
      this.section?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    readTranslations() {
      const source = this.querySelector('[data-offer-translations]')?.content;
      return {
        add: source?.querySelector('[data-add]')?.textContent.trim() || '',
        adding: source?.querySelector('[data-adding]')?.textContent.trim() || '',
        added: source?.querySelector('[data-added]')?.textContent.trim() || '',
        error: source?.querySelector('[data-error]')?.textContent.trim() || '',
        unavailable: source?.querySelector('[data-unavailable]')?.textContent.trim() || '',
      };
    }

    get tier() {
      return Number(this.querySelector('[data-offer-tier]:checked')?.value || 1);
    }

    get packRows() {
      return Array.from(this.querySelectorAll('[data-pack-row]'));
    }

    selectedPackVariantIds() {
      return this.packRows
        .slice(0, this.tier)
        .map((row) => Number(row.querySelector('[data-pack-variant]:checked')?.value))
        .filter(Boolean);
    }

    variantById(id) {
      return this.config.variants.find((variant) => Number(variant.id) === Number(id));
    }

    money(cents) {
      return new Intl.NumberFormat(this.config.locale, {
        style: 'currency',
        currency: this.config.currency,
      }).format(cents / 100);
    }

    handleChange(event) {
      if (!event.target.matches('[data-offer-tier], [data-pack-variant]')) return;
      this.render();
    }

    handleVariantUpdate(event) {
      if (String(event.detail?.data?.productId) !== String(this.dataset.productId)) return;
      const variant = event.detail?.resource;
      if (!variant) return;
      this.config.variantId = variant.id;
      this.config.variantAvailable = Boolean(variant.available);
      if (Number.isFinite(Number(variant.price))) this.config.unitPrice = Number(variant.price);
      const configuredVariant = this.variantById(variant.id);
      if (configuredVariant) {
        configuredVariant.available = Boolean(variant.available);
        if (Number.isFinite(Number(variant.price))) configuredVariant.price = Number(variant.price);
      }
      this.querySelectorAll('[data-pack-variant]').forEach((input) => {
        if (Number(input.value) !== Number(variant.id)) return;
        input.disabled = !Boolean(variant.available);
      });
      const firstPackInput = this.packRows[0]?.querySelector(`[data-pack-variant][value="${variant.id}"]`);
      if (firstPackInput && !firstPackInput.disabled) firstPackInput.checked = true;
      this.render();
    }

    offerAvailable() {
      const selectedVariants = this.selectedPackVariantIds();
      if (selectedVariants.length !== this.tier) return false;
      if (selectedVariants.some((id) => !this.variantById(id)?.available)) return false;
      if (this.tier >= 2 && (!this.config.gift.id || !this.config.gift.available)) return false;
      if (this.tier >= 3 && (!this.config.ebook.id || !this.config.ebook.available)) return false;
      return true;
    }

    render() {
      const tier = this.tier;
      this.packRows.forEach((row, index) => {
        row.hidden = index >= tier;
      });
      const total = this.selectedPackVariantIds().reduce((sum, id) => {
        return sum + Number(this.variantById(id)?.price || this.config.unitPrice);
      }, 0);
      this.total.textContent = this.money(total);
      this.submitButton.disabled = !this.offerAvailable();
      this.message.hidden = this.offerAvailable();
      if (!this.offerAvailable()) {
        this.message.dataset.error = 'true';
        this.message.textContent = this.translations.unavailable;
      }
    }

    cartItems() {
      const tier = this.tier;
      const offer = `calecons-tier-${tier}`;
      const quantitiesByVariant = new Map();
      this.selectedPackVariantIds().forEach((variantId) => {
        quantitiesByVariant.set(variantId, (quantitiesByVariant.get(variantId) || 0) + 1);
      });
      const items = Array.from(quantitiesByVariant, ([variantId, quantity]) => ({
        id: variantId,
        quantity,
        properties: { _offre_calecons: offer },
      }));
      if (tier >= 2) {
        items.push({
          id: Number(this.config.gift.id),
          quantity: 1,
          properties: { _offre_calecons: offer, _cadeau_calecons: 'ghassoul' },
        });
      }
      if (tier >= 3) {
        items.push({
          id: Number(this.config.ebook.id),
          quantity: 1,
          properties: { _offre_calecons: offer, _cadeau_calecons: 'ebook' },
        });
      }
      return items;
    }

    async addOffer() {
      if (!this.offerAvailable() || this.submitButton.disabled) return;
      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');
      this.spinner.hidden = false;
      this.buttonText.textContent = this.translations.adding;
      this.message.hidden = true;

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: this.cartItems(),
            sections: sectionIds,
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.translations.error);

        this.buttonText.textContent = this.translations.added;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              source: 'calecon-offer',
              itemCount: this.cartItems().reduce((total, item) => total + item.quantity, 0),
              productId: this.dataset.productId,
              sections: result.sections,
            },
          },
        }));
      } catch (error) {
        this.message.dataset.error = 'true';
        this.message.textContent = error.message || this.translations.error;
        this.message.hidden = false;
        this.buttonText.textContent = this.translations.error;
      } finally {
        this.submitButton.removeAttribute('aria-busy');
        this.spinner.hidden = true;
        window.setTimeout(() => {
          this.submitButton.disabled = !this.offerAvailable();
          if (this.offerAvailable()) this.buttonText.textContent = this.translations.add;
        }, 1800);
      }
    }
  }

  if (!customElements.get('calecon-offer')) customElements.define('calecon-offer', CaleconOffer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["siwak-product-offers"] && !Shopify.designMode) return;
  try {
    class SiwakProductOffers extends HTMLElement {
  connectedCallback() {
    this.initFrame = requestAnimationFrame(() => this.initialize());
  }
  initialize() {
    if (!this.isConnected) return;
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.dialog = this.querySelector('dialog');
    this.gift = null;
    this.cancelPendingSubmission();
    this.addEventListener('change', () => {
      this.syncForm();
      this.querySelector('[data-gift-count]').textContent = `${this.querySelector('.siwak-product-offers__gift input:checked') ? 1 : 0} / 1 cadeau sélectionné`;
    }, options);
    this.querySelector('.siwak-product-offers__gift-open').addEventListener('click', () => {
      this.cancelPendingSubmission();
      this.querySelectorAll('.siwak-product-offers__gift input').forEach(input => input.checked = input.value === this.gift?.value);
      this.querySelector('[data-gift-count]').textContent = `${this.gift ? 1 : 0} / 1 cadeau sélectionné`;
      this.dialog.showModal();
    }, options);
    this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click',()=>{this.cancelPendingSubmission();this.dialog.close();},options));
    this.dialog.addEventListener('cancel',()=>this.cancelPendingSubmission(),options);
    this.querySelector('[data-confirm]').addEventListener('click', () => {
      const input = this.querySelector('.siwak-product-offers__gift input:checked');
      if (!input || input.disabled) return;
      this.gift = {value:input.value,title:input.dataset.title};
      this.querySelector('[data-gift-summary]').textContent = this.gift?.title || '';
      this.syncForm();
      const pending = this.pendingSubmission;
      const submitter = this.pendingSubmitter;
      this.cancelPendingSubmission();
      this.dialog.close();
      if (pending) this.form?.requestSubmit(submitter?.form === this.form && !submitter.disabled ? submitter : undefined);
    }, options);
    this.form = this.closest('.shopify-section')?.querySelector('product-form-component form');
    this.observer = new MutationObserver(()=>this.syncForm());
    if (this.form) this.observer.observe(this.form,{childList:true,subtree:true});
    this.syncForm();
  }
  cancelPendingSubmission() {
    this.pendingSubmission = false;
    this.pendingSubmitter = undefined;
  }
  needsGiftSelection() {
    if (this.querySelector('input[name^="siwak-quantity"]:checked')?.value !== '4') return false;
    return !this.gift || !Array.from(this.querySelectorAll('.siwak-product-offers__gift input')).some(input => !input.disabled && input.value === this.gift.value);
  }
  prepareSubmission(submitter) {
    this.syncForm();
    if (!this.needsGiftSelection()) return true;
    this.pendingSubmission = true;
    this.pendingSubmitter = submitter;
    if (!this.dialog.open) this.dialog.showModal();
    return false;
  }
  disconnectedCallback() {cancelAnimationFrame(this.initFrame);this.controller?.abort();this.observer?.disconnect();}
  syncForm() {
    if (!this.form) return;
    const quantity = this.querySelector('input[name^="siwak-quantity"]:checked')?.value || '2';
    const subscription = this.querySelector('input[name^="siwak-mode"]:checked')?.value === 'subscription';
    let input = this.form.querySelector('[name="quantity"]');
    if (!input) {input=document.createElement('input');input.type='hidden';input.name='quantity';this.form.append(input);}
    input.value=quantity;
    const setHidden = (name,value) => {
      let field = Array.from(this.form.elements).find(el=>el.name===name);
      if (!value) {field?.remove();return;}
      if (!field) {field=document.createElement('input');field.type='hidden';field.name=name;this.form.append(field);}
      field.value=value;
    };
    setHidden('selling_plan',subscription ? this.dataset.plan : '');
    // The form adds the chosen gift without a selling plan; eligibility is enforced by Shopify.
    setHidden('properties[Cadeau choisi]',quantity==='4' ? this.gift?.title : '');
    setHidden('properties[_optiz_gift_variant]',quantity==='4' ? this.gift?.value : '');
    this.querySelectorAll('[data-price]').forEach(el=>el.textContent=`${Number(el.dataset.price)*(subscription?10:12)} €`);
    this.querySelectorAll('[data-value-quantity]').forEach(element => {
      const value = Number(element.dataset.valueQuantity) * (subscription ? 10 : 12) + Number(element.dataset.bonusValue);
      element.textContent = `${value} €`;
    });
    this.querySelectorAll('[data-unit]').forEach(el=>el.textContent=`${subscription?10:12} € / boîte`);
    this.querySelector('[data-renewal]').hidden=!subscription;
    this.querySelectorAll('[data-subscription-only]').forEach(element => element.hidden = !subscription);
    this.querySelectorAll('[data-ticket]').forEach(ticket => {
      ticket.querySelector('[data-panel]').hidden = ticket.dataset.ticket !== quantity;
    });
  }
}
if (!customElements.get('siwak-product-offers')) customElements.define('siwak-product-offers',SiwakProductOffers);
  } catch(e) { console.error(e); }
})();

})();
